// extracted by mini-css-extract-plugin
export default {"checkInput":"Checkbox_checkInput__P9GrJ","label":"Checkbox_label__yqSkM","error":"Checkbox_error__GHK18"};